// extracted by mini-css-extract-plugin
export var container = "CartTotal_container__DFZ0n";
export var item = "CartTotal_item__ZDyiE";
export var shared = "\"../../../shared/shared.module.css\"";
export var shipping = "CartTotal_shipping__20bO1";
export var shopCampaign = "CartTotal_shopCampaign__e+oMo";
export var sm = "576px";
export var tooltip = "CartTotal_tooltip__w+BK9";
export var total = "CartTotal_total__LE2SF";